import React from 'react';
import GeneratorBase from './GeneratorBase';
import { usePostingTime } from '../hooks/usePostingTime';

const HiringPostGenerator = () => {
  const postingTimeSummary = usePostingTime();

  const fields = [
    {
      name: 'jobRole',
      label: 'Job Role',
      type: 'text',
      placeholder: 'e.g., Senior Marketing Manager',
      required: true
    },
    {
      name: 'experienceLevel',
      label: 'Experience Level',
      type: 'select',
      options: [
        { value: 'Entry Level', label: 'Entry Level (0-2 years)' },
        { value: 'Mid Level', label: 'Mid Level (2-5 years)' },
        { value: 'Senior Level', label: 'Senior Level (5+ years)' },
        { value: 'Executive', label: 'Executive Level' }
      ],
      required: true
    },
    {
      name: 'skills',
      label: 'Required Skills',
      type: 'textarea',
      placeholder: 'e.g., Digital marketing, Content creation, SEO, Analytics, Team leadership',
      rows: 4,
      required: true
    },
    {
      name: 'location',
      label: 'Location (Optional)',
      type: 'text',
      placeholder: 'e.g., New York, NY or Remote',
      required: false
    }
  ];

  return (
    <GeneratorBase
      title="Hiring Post Generator"
      description="Generate professional LinkedIn hiring posts that attract top talent. Includes job responsibilities, required skills, and compelling CTAs."
      fields={fields}
      apiEndpoint="hiring-post"
      saveDraftEndpoint="hiring-post"
      enableLinkedIn={true}
      postingTimeSummary={postingTimeSummary}
    />
  );
};

export default HiringPostGenerator;
